const HERO_VIDEO_DESKTOP_MQ = '(min-width: 64rem)';
const HERO_VIDEO_IDLE_FALLBACK_MS = 2000;

/**
 * Loads hero background video only on desktop when a mobile image fallback exists.
 *
 * @return {void}
 */
export function initHeroDeferredVideo() {
	const videos = document.querySelectorAll('video[data-hero-video-src]');

	if (!videos.length) {
		return;
	}

	const mq = window.matchMedia(HERO_VIDEO_DESKTOP_MQ);
	const pendingAttach = new WeakMap();

	const attachSource = (video) => {
		const src = video.getAttribute('data-hero-video-src');

		if (!src || video.querySelector('source')) {
			return;
		}

		const type = video.getAttribute('data-hero-video-type');
		const source = document.createElement('source');

		source.src = src;

		if (type) {
			source.type = type;
		}

		video.appendChild(source);
		video.load();

		const playPromise = video.play();

		if (playPromise !== undefined) {
			playPromise.catch(() => {});
		}
	};

	const cancelScheduledAttach = (video) => {
		const pending = pendingAttach.get(video);

		if (!pending) {
			return;
		}

		if (pending.type === 'idle' && typeof cancelIdleCallback === 'function') {
			cancelIdleCallback(pending.id);
		} else {
			clearTimeout(pending.id);
		}

		pendingAttach.delete(video);
	};

	const scheduleAttach = (video) => {
		cancelScheduledAttach(video);

		if (!mq.matches || video.querySelector('source')) {
			return;
		}

		const run = () => {
			pendingAttach.delete(video);

			if (mq.matches) {
				attachSource(video);
			}
		};

		if (typeof requestIdleCallback === 'function') {
			const id = requestIdleCallback(run, { timeout: HERO_VIDEO_IDLE_FALLBACK_MS });

			pendingAttach.set(video, { type: 'idle', id });
		} else {
			const id = window.setTimeout(run, HERO_VIDEO_IDLE_FALLBACK_MS);

			pendingAttach.set(video, { type: 'timeout', id });
		}
	};

	const detachSource = (video) => {
		cancelScheduledAttach(video);
		video.pause();

		const source = video.querySelector('source');

		if (source) {
			source.remove();
		}

		video.load();
	};

	const sync = () => {
		videos.forEach((video) => {
			if (mq.matches) {
				scheduleAttach(video);
			} else {
				detachSource(video);
			}
		});
	};

	sync();

	if (typeof mq.addEventListener === 'function') {
		mq.addEventListener('change', sync);
	} else if (typeof mq.addListener === 'function') {
		mq.addListener(sync);
	}
}
